import useActiveGroup from '@/hooks/user/useActiveGroup';
import { useGlobalInfo } from '@/utils/hooks/context/useGlobalInfo';

import { GroupsMenuMobile } from '@/components/composite/SocialProfiles/SocialProfileGroupMenuMobile/Components/MenuContent/Groups/GroupsMenuMobile';
import { GroupMenuMobile } from '@/components/composite/SocialProfiles/SocialProfileGroupMenuMobile/Components/MenuContent/Group/GroupMenuMobile';
import { SocialProfilesMenuMobile } from '@/components/composite/SocialProfiles/SocialProfileGroupMenuMobile/Components/MenuContent/SocialProfiles';
import { SidebarWrapper } from '@/components/composite/SocialProfiles/SocialProfileGroupMenuMobile/Components/SideBarWrapper';
import { SideBarHeader } from '@/components/composite/SocialProfiles/SocialProfileGroupMenuMobile/Components/SideBarHeader';

type SocialProfileMobileMenuContentProps = Pick<SocialProfileGroupMobileMenu, 'toggleSideBar'>;
function SocialProfileMobileMenuContent({ toggleSideBar }: SocialProfileMobileMenuContentProps) {
    const { globalInfo } = useGlobalInfo();

    if (globalInfo.group.activeGroup) {
        return <SocialProfilesMenuMobile hasActiveItem={false} toggleSideBar={toggleSideBar} />;
    }

    return <SocialProfilesMenuMobile toggleSideBar={toggleSideBar} />;
}

type GroupsMobileMenuContentProps = Pick<SocialProfileGroupMobileMenu, 'toggleSideBar'>;
function GroupsMobileMenuContent({ toggleSideBar }: GroupsMobileMenuContentProps) {
    const { globalInfo } = useGlobalInfo();
    const { activeGroup } = useActiveGroup();

    if (globalInfo.menuSelectedGroupOpen) {
        return <GroupMenuMobile group={activeGroup} toggleSideBar={toggleSideBar} />;
    }

    return <GroupsMenuMobile />;
}

type MenuContentProps = Pick<SocialProfileGroupMobileMenu, 'toggleSideBar'>;
function MenuContent({ toggleSideBar }: MenuContentProps) {
    const { globalInfo } = useGlobalInfo();

    if (globalInfo.menuGroupActive) {
        return <GroupsMobileMenuContent toggleSideBar={toggleSideBar} />;
    }

    return <SocialProfileMobileMenuContent toggleSideBar={toggleSideBar} />;
}

type SocialProfileGroupMobileMenu = { isOpenSidebar: boolean; toggleSideBar: () => void };

export function SocialProfileGroupMobileMenu({
    isOpenSidebar,
    toggleSideBar
}: SocialProfileGroupMobileMenu) {
    return (
        <SidebarWrapper isOpenSidebar={isOpenSidebar} toggleSideBar={toggleSideBar}>
            <div className="flex w-full flex-col space-y-5">
                <SideBarHeader />
                <div className="px-2">
                    <MenuContent toggleSideBar={toggleSideBar} />
                </div>
            </div>
        </SidebarWrapper>
    );
}
